import {
  ApiClient,
  ApiErrorMessage,
  NoticeMessageListResponsType
} from './ApiClient';

export const GetNoticeMessageListApi =
  async (): Promise<NoticeMessageListResponsType> => {
    try {
      const response = await ApiClient.get('/message', {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      });
      return { success: true, data: response.data, message: null };
    } catch (err) {
      const error = ApiErrorMessage(err);
      return { success: false, data: null, message: error?.data };
    }
  };

export const DeleteNoticeMessageListApi = async (
  id: number
): Promise<NoticeMessageListResponsType> => {
  try {
    const response = await ApiClient.delete('/message/' + id, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
